import { getItem, removeItem, setItem } from "./localStorage";

const SJ_LOCAL_STORAGE_KEY = 'SJ_LOCAL_COUPON'

export const sjLocalStorageHandler = (method: 'GET' | 'SET' | 'DELETE', coupon?: string) => {
  if (method === 'SET' && coupon) {
    setItem(SJ_LOCAL_STORAGE_KEY, coupon)
    console.log(`[${method}][sjLocalStorageHandler]`, coupon)
  }
  if (method === 'DELETE') {
    removeItem(SJ_LOCAL_STORAGE_KEY);
    console.log(`[${method}][sjLocalStorageHandler]`)
  }
  return getItem(SJ_LOCAL_STORAGE_KEY)
};
